import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export class FormError {
  [key: string]: FormError | boolean;
}

@Injectable()
export class FormValidationService {
  protected formSubject: BehaviorSubject<FormError> =
    new BehaviorSubject<FormError>({});

  constructor() {}

  clearForm() {
    this.formSubject.next({});
  }

  addFormError(path: string[], form: FormError | boolean) {
    const formErrors = this.getForm();
    let current: FormError | boolean = formErrors;
    path.forEach((p) => {
      if (current[p] == undefined && p == path.slice(-1)[0]) current[p] = form;
      else if (current[p] == undefined) current[p] = {};
      current = current[p];
    });
    this.setForm(formErrors);
  }

  getFormObservable() {
    return this.formSubject.asObservable();
  }

  getForm(): FormError {
    return JSON.parse(JSON.stringify(this.formSubject.value));
  }

  private setForm(form: FormError) {
    this.formSubject.next(form);
  }

  resetErrorsForPath(...path: string[]) {
    let resetErrors: (c: FormError) => FormError;
    resetErrors = (c: FormError) => {
      Object.keys(c).forEach((k) => {
        if (typeof c[k] == "boolean") c[k] = false;
        else c[k] = resetErrors(c[k] as FormError);
      });
      return c;
    };
    const formErrors = this.getForm();
    let current: FormError | boolean = formErrors;
    path.forEach((p) => (current = current?.[p]));
    if (typeof current == "boolean") return;
    current = resetErrors(current);
    this.setForm(formErrors);
  }

  addError(...path: string[]) {
    const formErrors = this.getForm();
    let current: FormError | boolean = formErrors;
    path.forEach((p) => {
      if (p == path.slice(-1)[0] && typeof current[p] == "boolean")
        current[p] = true;
      else if (typeof current[p] != "boolean") current = current[p];
    });
    this.setForm(formErrors);
  }

  getErrors(...path: string[]): boolean {
    let checkErrors: (c: FormError) => boolean;
    checkErrors = (c: FormError) =>
      Object.keys(c).some((k) =>
        typeof c[k] == "boolean" ? c[k] : checkErrors(c[k] as FormError)
      );
    const formErrors = this.getForm();
    let current: FormError | boolean = formErrors;
    path.forEach((p) => (current = current?.[p]));
    if (current == undefined) return false;
    if (typeof current == "boolean") return current;
    return checkErrors(current as FormError);
  }
}
